import { CategoryService } from '@app/shared/services/Category.service';
import { tap } from 'rxjs/operators';
import {
  Component,
  OnInit,
  Injector,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { TreeNode, FlatNode } from '@product/shared/models/tree-view';
import { NzTreeFlattener, NzTreeFlatDataSource } from 'ng-zorro-antd/tree-view';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { Category } from '@app/shared/interfaces/Category';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { BaseProductComponent } from '@product/shared/base-product.component';
import {
  NzFormatEmitEvent,
  NzTreeComponent,
  NzTreeNode,
} from 'ng-zorro-antd/tree';
import { TreeCategory } from '@product/shared/models/category';
// import {} from '';
@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.less'],
  animations: [
    trigger('fade', [
      transition('void=>*', [style({ opacity: 0 }), animate(300)]),
      transition('*=>void', [
        style({ opacity: 100 }),
        animate(300, style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class CategoriesComponent
  extends BaseProductComponent
  implements OnInit
{
  categories: TreeCategory[] = [];
  isLoading = true;
  nodes: {};
  searchValue = '';
  editMode: boolean = false;
  _selectedCategories: Set<number> = new Set<number>();
  expandedNodes: Set<number> = new Set<number>();
  @Output() nodesSelectionChanged = new EventEmitter();
  @Input() Disabled: boolean = false;
  @Input() set selectedCategories(value: number[]) {
    this._selectedCategories = new Set(value);
    // const ids = value.map((x) => x.toString());
    // this.handlerSelectedNodes(ids);
  }
  constructor(injector: Injector, private categoryService: CategoryService) {
    super(injector);
  }

  ngOnInit() {
    this.getCategories();
  }

  getCategories() {
    this.productService
      .getCategories()
      .pipe(
        tap((response) => {
          this.categories = [...response];
          this.isLoading = false;
          this.expandSelectedNodes();
        })
      )
      .subscribe();
  }

  hasChildren(category: Category, categories: Category[]) {
    return categories.find((x) => x.ParentId === category.Id) != null;
  }
  nodeSelectionChanged(categoryId: number) {
    this._selectedCategories.has(categoryId)
      ? this._selectedCategories.delete(categoryId)
      : this._selectedCategories.add(categoryId);
    this.nodesSelectionChanged.emit(Array.from(this._selectedCategories));
  }

  onSearchChange(value: any) {}
  deleteCategory(node: any) {}
  // createCategory(node: any, name: string) {
  //   const parentNode = this.findParent(node.id, this.categoryNodes);
  //   this.categoryService
  //     .AddNewCategory({
  //       Name: name,
  //       ParentId: +parentNode?.key,
  //       Position: 0,
  //       Id: 0,
  //       InverseParent: [],
  //     })
  //     .pipe(
  //       tap((response: any) => {
  //         if (parentNode != null) {
  //           const nod = parentNode.children?.findIndex(
  //             (x) => x.key == node.key
  //           );
  //           parentNode.children = parentNode.children?.splice(nod!, 1);
  //           parentNode.children?.push({
  //             key: response.Id,
  //             title: response.Name,
  //             children: [],
  //           });
  //         } else {
  //           const index = this.categoryNodes.findIndex(
  //             (x) => x.key == node.key
  //           );
  //           this.categoryNodes = this.categoryNodes.splice(index, 1);
  //           this.categoryNodes.push({
  //             key: response.Id,
  //             title: response.Name,
  //             children: [],
  //           });
  //         }
  //         this.handlerSelectedNodes(this.selectedNodesIds);
  //       })
  //     )
  //     .subscribe();
  // }

  expandSelectedNodes() {
    const allCategories = this.flattenCategories(this.categories);
    this._selectedCategories.forEach((id) => {
      this.expandParentNode(
        allCategories,
        allCategories.find((x) => x.id == id)
      );
    });
  }
  // flattenCategories(categories: TreeCategory[]): TreeCategory[] {
  //   const result: TreeCategory[] = [];

  //   categories.forEach(category => {
  //     result.push(category);

  //     if (category.childCategories.length > 0) {
  //       const childCategories = this.flattenCategories(category.childCategories);
  //       result.push(...childCategories);
  //     }
  //   });

  //   return result;
  // }
  expandParentNode(flattenCategories: TreeCategory[], category?: TreeCategory) {
    if (category == null) {
      return;
    }
    const parent = flattenCategories.find((x) =>
      x.childCategories.includes(category)
    );
    if (parent != null) {
      this.expandedNodes.add(parent.id);
      this.expandParentNode(flattenCategories, parent);
    }
  }
  flattenCategories(data: TreeCategory[]): TreeCategory[] {
    return data.flatMap((item) => [
      item,
      ...(item.childCategories == null
        ? []
        : this.flattenCategories(item.childCategories)),
    ]);
  }
  findNode(key: string, nodes: TreeNode[]) {
    let node: TreeNode;
    nodes.forEach((catNode) => {
      if (catNode.key === key) {
        node = catNode;
      } else if (catNode.children != null && catNode.children.length > 0) {
        node = this.findNode(key, catNode.children);
      }
    });
    return node!;
  }
  findParent(key: string, nodes: TreeNode[]) {
    let node: TreeNode;
    if (nodes.find((x) => x.key == key) != null) {
      node = {
        key: '0',
        title: '',
        children: [],
      };
      return node;
    } else {
      nodes.forEach((nod) => {
        if (nod.children != null && nod.children.length > 0) {
          if (nod.children.find((x) => x.key == key)) {
            node = nod;
            return;
          } else {
            node = this.findParent(key, nod.children!);
          }
        }
      });
    }
    return node!;
  }
}
